module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlistados-socios/adminlistados-socios.component.scss
// module id = ./src/app/adminlistados-socios/adminlistados-socios.component.scss
// module chunks = main